'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [{ code: 'en', name: 'English' }, { code: 'de', name: 'Deutsch' }, // german
{ code: 'es', name: 'Español' }, // spanish
{ code: 'fr', name: 'Français' }, // french
{ code: 'it', name: 'Italiano' }, // italian
{ code: 'ja', name: '日本語' }, // japanese
{ code: 'ko', name: '한국어' }, { code: 'nl', name: 'Nederlands' }, // dutch
{ code: 'pl', name: 'Polski' }, // polish
{ code: 'ru', name: 'Русский' }, // russian
{ code: 'zh', name: '简体中文' }];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/intl/UILanguages.js
// module id = QBdC
// module chunks = 60